import { render, staticRenderFns } from "./AdminLeadsByStatusUat.vue?vue&type=template&id=159be94c&scoped=true&"
import script from "./AdminLeadsByStatusUat.vue?vue&type=script&lang=js&"
export * from "./AdminLeadsByStatusUat.vue?vue&type=script&lang=js&"
import style0 from "./AdminLeadsByStatusUat.vue?vue&type=style&index=0&id=159be94c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159be94c",
  null
  
)

export default component.exports